module.exports = __webpack_public_path__ + "img/269.509343df.jpg";